/**
 * Single source of truth for the application marketing source
 * ("Wie haben Sie uns gefunden?").
 *
 * Backend stores one of the codes below in `application.source`; an optional
 * free-text detail lives in `application.source_other` (only for referral /
 * sonstiges). Unknown codes fall back to showing the code itself.
 */
export const APPLICATION_SOURCE_LABELS = {
  google: "Google",
  facebook_instagram: "Facebook/Instagram",
  direct_website: "Direkt",
  referral: "Empfehlung",
  sonstiges: "Sonstiges",
};

/** Label for a source code, or the code itself / "—" as fallback. */
export function applicationSourceLabel(source) {
  if (!source) return "—";
  return APPLICATION_SOURCE_LABELS[source] || source;
}

/** Full detail display: label, plus the free-text detail for referral/sonstiges.
 *  e.g. "Empfehlung — Marco", "Sonstiges — Plakat Bahnhof". Empty source -> "—". */
export function formatApplicationSource(source, sourceOther) {
  if (!source) return "—";
  const label = applicationSourceLabel(source);
  const other = (sourceOther || "").trim();
  if (other && (source === "referral" || source === "sonstiges")) {
    return `${label} — ${other}`;
  }
  return label;
}
